<template>
    <div>
        <div v-if="!dialogVisible">
            <div style="font-size: 20px; margin-top: 40px; margin-left: 40px; font-weight: 600;">员工信息列表</div>
            <el-row style="margin-top: 9px;">
                <div style="height: 750px; background-color: #FFFFFF; margin: 0px 40px; border: 1px solid #eaebed">

                    <el-row>

                        <!-- 左侧组织架构 --> 
                        <el-col :span="4" style="background-color: #f7f8fa; height: 750px;">
                            <Structure ref="Structure" @parentFind="Find" :condition="condition"></Structure>
                        </el-col>

                        <!-- 右侧列表 -->
                        <el-col :span="20">

                            <el-row style="padding-left: 46px; padding-top: 40px;">

                                <el-col :span="5">
                                    <span>所在职位</span>
                                    <el-select v-model="condition.post_id" placeholder="全部"
                                        style="width: 70%; margin-left: 10px;" clearable filterable>
                                        <el-option v-for="item in postList" :key="item.id" :label="item.post_name"
                                            :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-col>

                                <el-col :span="5">
                                    <span style="margin-left: 10px;">姓名</span>
                                    <el-input v-model="condition.staff_name" placeholder="请输入姓名"
                                        style="width: 70%; margin-left: 10px;"></el-input>
                                </el-col>

                                <el-col :span="6">
									<span>身份证号</span>
									<el-input v-model="condition.staff_card" placeholder="请输入身份证号"
										style="width: 70%; margin-left: 10px;"></el-input>
								</el-col>

                                <el-col :span="4">
                                    <el-button
                                        style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
                                        @click="Find">
                                        查询</el-button>
                                </el-col>

                                <el-col :span="2">
									<div style="display:inline-block;margin-left:220px">
										<download-excel class="export-excel-wrapper" :fields="download_excel" title="缴纳人员清单"
													name="架构人员清单.xls" :fetch="ExportForm"
													style="margin-left:-180px;top:100px">
											<el-button type="goon" style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;">
												导表</el-button>
										</download-excel>
									</div>
								</el-col>
                            </el-row>

                            <el-row style="margin: 0px 2%; margin-top: 10px;">
                                <el-row>
                                    <el-table :header-cell-style="{background:'#F0F0F0',color:'#000000'}"
                                        :row-class-name="tableRowClassName" ref="multipleTable" :data="tableData"
                                        height="530" tooltip-effect="dark" style="width: 100%;"
                                        @selection-change="handleSelectionChange">
                                        <el-table-column type="selection" width="55">
                                        </el-table-column>
                                        <el-table-column align="center" label="序号">
                                            <template slot-scope="scope_1">{{scope_1.$index + 1}}</template>
                                        </el-table-column>
                                        <el-table-column prop="staff_name" align="center" label="姓名"></el-table-column>
                                        <el-table-column prop="staff_card" align="center" label="身份证号">
                                        </el-table-column>
                                        <el-table-column prop="bankuai" align="center" label="年龄"></el-table-column>
                                        <el-table-column prop="" align="center" label="性别">
                                            <template slot-scope="scope">
												{{ scope.row.staff_gender == '1' ? '男':'女' }}
            								</template>
                                        </el-table-column>
                                        <el-table-column prop="staff_telephone" align="center" label="手机号">
                                        </el-table-column>
                                        <el-table-column prop="gangwei" align="center" label="招聘方式"></el-table-column>
                                        <!-- <el-table-column prop="project_name" align="center" label="所在部门">
                                        </el-table-column> -->
                                        <el-table-column prop="post_name" align="center" label="所在职位"></el-table-column>
                                        <el-table-column prop="induction_time" align="center" label="入职时间">
                                        </el-table-column>
                                        <el-table-column align="center" label="操作">
                                            <template slot-scope="scope">
                                                <img src="../../../assets/详情.png" @click="Edit(scope.row.id)" />
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </el-row>
                                <el-row style="margin-top: 10px; text-align: center;">
                                    <el-pagination background @current-change="handleCurrentChange"
                                        :page-size="page_size" layout=" prev, pager, next, jumper" :total="total">
                                    </el-pagination>
                                </el-row>
                            </el-row>

                        </el-col>
                    </el-row>

                </div>
            </el-row>
        </div>

        <div v-if="dialogVisible">
            <edit ref="edit"></edit>
        </div>

    </div>
</template>

<script>
    import Structure from "../../utils/structure/structure.vue";
    import edit from "./Ygxxlb_edit.vue";

    import axios from "axios";
    export default {
        components: {
            Structure: Structure,
            edit: edit,
        },
        data() {
            return {
                //列表相关
                page_num: 1,
                page_size: 10,
                total: 0,
                tableData: [],

                //页面相关
                dialogVisible: false,

                //职位下拉
                postList: [],

                //条件
                condition: {
                    project_id: "",
                    flag: "",
                    post_id: "",
                    staff_name: "",
                    induction_time: "",
                    staff_card:"",
                },

                download_excel: {
				    "组织架构": "organize_name",
				    "归属部门或项目名称": "range",
				    "姓名": "staff_name",
					"性别":"staff_gender",
				    "职位": "post_name",
				    "身份证号": {
						field: "staff_card",
						callback: value => {
							return "&nbsp;" + value;
						}
					},
				    "手机号": "staff_telephone",
				    "入职时间": "induction_time",
				    "员工状态": "spare6",
					"现薪资":"spare5",
				},

                //详情
                from: {
                    id: "",
                    name: "",
                    pwd: "",
                    role_id: "",
                    staff_id: "",
                    phone: "",
                    mailbox: "",
                },

                //复选框ids
                ids: [],
            };
        },
        methods: {
            Return() {
                this.dialogVisible = false;
                this.Find();
            },
            //查询
            Find() {
                const url = this.$globals.http + "staff/selectWhole";
                axios.post(url, {
                    page_num: this.page_num,
                    page_size: this.page_size,
                    post_id: this.condition.post_id,
                    staff_name: this.condition.staff_name,
                    staff_card:this.condition.staff_card,
                    organize_id: this.condition.project_id,
                    flag: this.condition.flag,
                }).then((response) => {
                    var code = response.data.code;
                    var data = response.data.data;

                    if (code === '200') {

                        this.tableData = data.list;
                        this.total = data.total;

                    } else {
                        this.$message.warning("请求失败！请稍后重试");
                    }
                }).catch((error) => {
                    console.log(error)
                    this.$message.error("服务器未响应！请稍后重试");
                })
            },

            async ExportForm(){
				var url = 'staff/selectOrganizeStaff';
				var record = {
					organize_id: this.condition.project_id,
					post_id: this.condition.post_id,
					staff_name: this.condition.staff_name,
					staff_card:this.condition.staff_card,
				};
				var data = await this.$globals.AxiosPost(url, record);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						if(data.length > 0){
							this.$message.success("导表成功！文件下载中！");
							return data;
						}else{
                            this.$message.success("没有可以导出的数据！");
                            return null;
                        }
						
					}
				}
			},

            //分页
            handleCurrentChange(val) {
                this.page_num = val
                this.Find();
            },
            //详情页面
            Edit(e) {
                this.from.id = e;
                this.dialogVisible = true;
            },

        },
        async created() {
            // this.Find();
            //初始化职位下拉
            var postList = await this.$globals.AxiosPost("post/selectFind", {});
            this.postList = postList.data;
        }
    }
</script>

<style scoped="scoped">
    >>>.el-button:hover {
        background-color: #FFFFFF;
    }

    >>>.el-button:focus {
        background-color: #FFFFFF;
    }

    >>>.el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #006E4B;
    }

    >>>.el-input__inner:focus {
        border-color: #006E4B;
    }

    >>>.el-select .el-input.is-focus .el-input__inner {
        border-color: #006E4B;
    }

    >>>.el-checkbox__input.is-checked .el-checkbox__inner,
    >>>.el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: #006E4B;
        border-color: #006E4B;
    }

    >>>.el-checkbox__inner:hover {
        border-color: #006E4B;
    }
    >>>.el-tree-node.is-expanded>.el-tree-node__children {
		display: inline;
	}
</style>



// WEBPACK FOOTER //
// Ygxxlb.vue?67259a9a